<template>
  <div>
    <button class="button button-white" @click="dialogChangeStatus = true">
      <b-icon icon="repeat" custom-size="mdi-18px"></b-icon>
      <span>{{ title }}</span>
    </button>
    <el-dialog :title="title" :visible.sync="dialogChangeStatus" width="400px" :lock-scroll="false">
      <!-- <span>transaction_id: {{ transaction_id }}</span><br> -->
      <div class="grid">
        <el-select v-model="state_id" placeholder="Выберите статус" size="medium" class="u-16">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.human_name"
            :value="item.id"
          ></el-option>
        </el-select>
        <div style="margin: 10px 0">
          <label for="">Дата учета</label>
          <el-date-picker
            type="date"
            v-model="changeDate"
            placeholder="Выберите дату учета"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div style="margin:10px 0 10px 0;">
          <label for="desc-change-state">Причина смены статуса:</label>
          <el-input
            id="desc-change-state"
            type="textarea"
            v-model="disable_update_desc"
            :autosize="{ minRows: 4, maxRows: 6}"
            style="width:360px;"
          ></el-input>
        </div>
        <div>
          <el-checkbox style="display:inline;"
            id="disable-update-state"
            v-model="disable_update_state"
          />
          <label style="display:inline;" for="disable-update-state">Запретить смену статуса</label>
        </div>
      </div>
      <span slot="footer" class="grid start">
        <el-button @click="dialogChangeStatus = false">Отмена</el-button>
        <el-button
          type="primary"
          @click="changeStatus(state_id, transaction_id, disable_update_desc, disable_update_state)"
          :loading="loading"
        >Подтвердить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios      from "axios";
import { apiUrl } from "@/api/apiUrl.js";
import errors     from "@/localize/errors.js";
import moment     from 'moment-timezone'
import {_}        from 'vue-underscore'

export default {
  name: "changeStatusDialog",
  props: ["transaction_id", "statusList", "disable_update_desc","disable_update_state"],
  data() {
    return {
      loading: false,
      state_id: null,
      title: "Изменить статус",
      dialogChangeStatus: false,
      changeDate: null
    };
  },
  methods: {
    changeStatus(state) {
      var params = {
        transaction_id: this.transaction_id,
        state_id: this.state_id,
        description: this.disable_update_desc,
        disable_update_state: this.disable_update_state,
        change_date: this.changeDate
      };
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      this.loading = true;
      axios
        .post(apiUrl + "state/change", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Статус успешно изменен",
              type: "success"
            });
            setTimeout(() => {
              this.$emit("loadAsyncData");
            }, 500);
            this.dialogChangeStatus = false;
          } else {
            this.$message.error(errors[data.error_code]);
          }
          this.loading = false;
        })
        .catch(err => {
          this.$message.error(errors[err.response.data.error_code]);
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
